// extracted by mini-css-extract-plugin
export var container = "_g1-0";
export var content = "_g1-3";
export var customerTitle = "_g1-4";
export var empty = "_g1-5";
export var gray = "_g1-6";
export var header = "_g1-7";
export var info = "_g1-8";
export var loading = "_g1-2";
export var loadingCard = "_g1-9";
export var oneLine = "_g1-a";
export var personName = "_g1-e";
export var pillContainer = "_g1-b";
export var selected = "_g1-1";
export var text = "_g1-c";
export var twoLines = "_g1-d";
export var unread = "_g1-f";
export var unreadIndicator = "_g1-g";